<template>
  <div>
    <AsideBar />
    <MainCont />
  </div>
</template>

<script>
import MainCont from "../components/mainDash/MainCont.vue";
import AsideBar from "../components/mainDash/AsideBar.vue";

export default {
  name: "Dashboard",
  components: {
    AsideBar,
    MainCont,
  },
  mounted() {
    if (document.getElementById("dropdownMenuButton")) {
      document.getElementById("dropdownMenuButton").innerHTML =
        "Select Website";
    }
  },
};
</script>
